import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import ProductsPage from "../pages/products/page";
import FavoritesPage from "../pages/favorites/page";
import OrderDetailPage from "../pages/order/page";
import CheckoutPage from "../pages/checkout/page";
import AdminPage from "../pages/admin/page";
import AuthPage from "../pages/auth/page";
import AccountPage from "../pages/account/page";
import DealsPage from "../pages/deals/page";
import TrackOrderPage from "../pages/track-order/page";
import RewardsPage from "../pages/rewards/page";
import AboutPage from "../pages/about/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import TermsPage from "../pages/terms/page";
import ResetPasswordPage from "../pages/reset-password/page";
import RedeemPage from "../pages/redeem/page";
import AdminOrderDetailPage from "../pages/admin/order-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/favorites",
    element: <FavoritesPage />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/order/:ref",
    element: <OrderDetailPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/order/:ref",
    element: <AdminOrderDetailPage />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/account",
    element: <AccountPage />,
  },
  {
    path: "/deals",
    element: <DealsPage />,
  },
  {
    path: "/track-order",
    element: <TrackOrderPage />,
  },
  {
    path: "/rewards",
    element: <RewardsPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/redeem",
    element: <RedeemPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
